import api from "../utils/api";

export const getMoleculesWithRates = async () => {
  const response = await api.get("/convert");
  return response.data;
}